// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 0;
    justify-content: center;
    align-items: center;
    height: auto;
    min-height: 100%;
    padding-bottom: 200px;
}

.contextTitle {
    font-size: 25px;
    font-weight: bolder;
}

.titleSeparator {
    max-width: 30%;
    border: none;
    height: 2px;
    background-color: #a7c898;
    margin-top: 15px;
}

.map-container {
    display: flex;
    justify-content: center;
    align-items: center; /* 좌우 정렬 및 세로 중앙 정렬 */
    gap: 5px; /* 지도와 정보 사이의 간격 */
    margin: 40px auto;
    width: 90%;
}

.map {
    width: 400px;
    height: 400px;
    background-color: #f0f0f0;
}

.map-info {
    background-color: rgba(211, 230, 202, 0.3);
    width: 400px;
    height: 400px;
    font-family: Arial, sans-serif;
    font-size: 15px;
    line-height: 1.6;
    text-align: start;
    color: #565b61;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.map-subinfo {
    margin-bottom: 15px;
    padding-left: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Map/styles.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,SAAS;IACT,UAAU;IACV,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB,EAAE,qBAAqB;IAC1C,QAAQ,EAAE,kBAAkB;IAC5B,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".context {\n    font-family: Arial, sans-serif;\n    margin: 0;\n    padding: 0;\n    justify-content: center;\n    align-items: center;\n    height: auto;\n    min-height: 100%;\n    padding-bottom: 200px;\n}\n\n.contextTitle {\n    font-size: 25px;\n    font-weight: bolder;\n}\n\n.titleSeparator {\n    max-width: 30%;\n    border: none;\n    height: 2px;\n    background-color: #a7c898;\n    margin-top: 15px;\n}\n\n.map-container {\n    display: flex;\n    justify-content: center;\n    align-items: center; /* 좌우 정렬 및 세로 중앙 정렬 */\n    gap: 5px; /* 지도와 정보 사이의 간격 */\n    margin: 40px auto;\n    width: 90%;\n}\n\n.map {\n    width: 400px;\n    height: 400px;\n    background-color: #f0f0f0;\n}\n\n.map-info {\n    background-color: rgba(211, 230, 202, 0.3);\n    width: 400px;\n    height: 400px;\n    font-family: Arial, sans-serif;\n    font-size: 15px;\n    line-height: 1.6;\n    text-align: start;\n    color: #565b61;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.map-subinfo {\n    margin-bottom: 15px;\n    padding-left: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
